var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("entity-reader", {
    attrs: {
      entity: "monster",
      id: _vm.id,
      "api-name": "monsters",
      "use-sharing": true,
      "allow-copy": true
    },
    scopedSlots: _vm._u(
      [
        {
          key: `reader`,
          fn: function({ doc }) {
            return [
              _c("label-value", { attrs: { name: "Name", value: doc.name } }),
              _c("label-value", {
                attrs: { name: "Section", value: doc.section }
              }),
              _c("label-value", { attrs: { name: "Race", value: doc.race } }),
              _c("label-value", {
                attrs: { name: "Weakness", value: doc.elementalWeakness }
              }),
              _c("label-value", {
                attrs: { name: "Pattern Type", value: _vm.getPattern(doc) }
              }),
              _c("label-value", { attrs: { name: "Hits", value: doc.hits } }),
              _c("label-value", {
                attrs: { name: "Armour", value: doc.armour }
              }),
              _c("label-value", {
                attrs: { name: "Dismiss/Control", value: doc.dismissControl }
              }),
              _c("label-value", {
                attrs: { name: "Intelligence", value: _vm.getIntelligence(doc) }
              }),
              _c("label-value", {
                attrs: { name: "Immunities", value: doc.immunities }
              }),
              _c("label-value", {
                attrs: { name: "Strikes For", value: doc.strikesFor }
              }),
              _c("label-value", {
                attrs: { name: "Summoning", value: doc.summoningAbility }
              }),
              _c("label-value", {
                attrs: { name: "Ability", value: _vm.getAbilities(doc) }
              }),
              _c("label-value", {
                attrs: { name: "Notes", value: doc.restrictionsAndNotes }
              }),
              _c("label-value", {
                attrs: { name: "Guidelines", value: doc.roleplayGuidelines }
              }),
              _c("label-value", {
                attrs: { name: "Makeup Notes", value: doc.makeupNotes }
              }),
              _c("label-value", {
                attrs: { name: "Upstat", value: doc.upstats }
              })
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }